import { NgModule } from '@angular/core';

import { MwArrowTogglerComponent } from './arrow-toggler.component';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [CommonModule, MatIconModule, MatButtonModule],
  exports: [MwArrowTogglerComponent],
  declarations: [MwArrowTogglerComponent],
  providers: [],
})
export class MwArrowTogglerModule {}
